import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
// import router from '@/router'

Vue.use(Vuex)

// const mainurl = 'http://192.168.1.105:8000';
const mainurl = 'https://appapi.akambc.com';

let state = {
    warranties: [],
}
const mutations = {
    nothing(){},

    warranty_list(state , warranties){
        Vue.set(state, 'warranties', warranties);
        Vue.set(state, 'warranties', [...warranties]);
    },

    add_warranty(state, warranty){
        state.warranties.unshift(warranty)
    },

    edit_warranty(state, payload){
        const item = state.warranties.find(item => item.id === payload.id);
        Object.assign(item, payload);
    },

    delete_warranty(state, id){
        const itemIndex = state.warranties.findIndex(item => item.id === id);
        state.warranties.splice(itemIndex , 1);
    },

}
const actions = {
    getwarranties({ dispatch, commit }, info){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/warranties?page=${info.page}`, method: 'GET' })
            .then(res => {
                commit('warranty_list', res.data.data)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    addWarranty({ commit }, warranty) {
        return new Promise((resolve, reject) => {
          axios({ url: `${mainurl}/api/admin/warranty/new`, data: warranty, method: 'POST' })
            .then(res => {
              commit("add_warranty", res.data)
              resolve(res)
            })
            .catch(err => {
              reject(err)
            })
        })
      },

    getWarrantyInfo({ dispatch, commit }, id){
        commit('nothing')
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/warranties/${id}`, method: 'GET' })
            .then(res => {
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    updateWarrantyInfo({ dispatch, commit }, payload){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/warranty/edit/${payload.id}`, data: payload, method: 'POST' })
            .then(res => {
                commit('edit_warranty', payload)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    },

    deleteWarranty({ dispatch, commit }, id){
        return new Promise((resolve,reject) => {
            axios({ url: `${mainurl}/api/admin/warranty/delete/${id}`, method: 'DELETE' })
            .then(res => {
                commit('delete_warranty' , id)
                resolve(res)
            })
            .catch(err => {
                if (err.response.status === 401) {
                    dispatch('goLogin')
                }
                reject(err)
            })
        })
    }

}
const modules = {

}
const getters = {
}
export default({
    state,
    mutations,
    actions,
    getters,
    modules,
    axios
})
